import { ClipboardState } from '@/store/modules/clipboard/state';
import { GetterTree } from 'vuex';
import { RootState } from '@/store/state';

export type Getters<S = ClipboardState> = {
  state(state: S): ClipboardState;
};

export interface NamespacedGetters {
  'clipboard/state': ClipboardState;
  'clipboard/data': string;
}

export const getters: GetterTree<ClipboardState, RootState> & Getters = {
  state: (state) => {
    return state;
  },
  data: (state) => {
    return state.dataInClipboard;
  }
};
